import {
  Button,
  CloseButton,
  Dialog,
  Flex,
  Portal,
  Text,
} from '@chakra-ui/react';
import { formatDate } from '@utils/date';
import { PiWarningDuotone } from "react-icons/pi";
import CustomDialogBackdrop from '@components/CustomDialogBackdrop';

import type { PendingExecutionType } from '../types';

type Props = {
  pendingExecutionDetails: PendingExecutionType;
  handleClose: () => void;
  onStartExecutionClick: () => void;
  onCheckPendingExecutionsClick: () => void;
};

const PendingCampaignExecutionDialog = ({
  pendingExecutionDetails,
  handleClose,
  onStartExecutionClick,
  onCheckPendingExecutionsClick,
}: Props) => (
  <Dialog.Root
    size="md"
    placement="center"
    open
    onOpenChange={handleClose}
    closeOnInteractOutside={false}
  >
    <Portal>
      <CustomDialogBackdrop />
      <Dialog.Positioner>
        <Dialog.Content bg="grayscale.fg" margin={4}>
          <Flex alignItems="center" justifyContent="center" mb={6} mt={8} color="yellow.500">
            <PiWarningDuotone size={48} />
          </Flex>

          <Dialog.Body>
            <Text fontSize="lg" textAlign="center" fontWeight={600} mb={6} lineHeight={1.2}>
              Você possui
              {' '}
              <Text as="span" color="red.500" fontWeight={700}>
                {pendingExecutionDetails.open_dispositions}
              </Text>
              {' '}
              {pendingExecutionDetails.open_dispositions > 1 ? 'atendimentos pendentes' : 'atendimento pendente'}
              !
            </Text>
            <Text fontSize="lg" textAlign="center" mb={1}>
              O mais antigo está em aberto desde
              {' '}
              <Text as="span" color="red.500" fontWeight={700}>
                {formatDate(pendingExecutionDetails.last_disposition_date_time)}
              </Text>
              .
            </Text>
          </Dialog.Body>

          <Flex justifyContent="center" m={4} direction="column" gap={3}>
            <Button
              onClick={() => {
                handleClose();
                onCheckPendingExecutionsClick();
              }}
              variant="solid"
              bg="green.700"
              color="white"
            >
              Verificar atendimentos pendentes
            </Button>
            <Button
              onClick={() => {
                handleClose();
                onStartExecutionClick();
              }}
              variant="subtle"
            >
              Continuar com novos atendimentos
            </Button>
          </Flex>

          <Dialog.CloseTrigger asChild>
            <CloseButton size="sm" />
          </Dialog.CloseTrigger>
        </Dialog.Content>
      </Dialog.Positioner>
    </Portal>
  </Dialog.Root>
);

export default PendingCampaignExecutionDialog;
